import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bootStrapColor: "warning",
};

const counterSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {},
});

export default counterSlice.reducer;
